import { useContext } from "react";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachmentsButton } from "../../../common";
import { MaterialOrderContext, RefetchScope } from "../context/MaterialOrderContext";

export default function MaterialOrderFilesButton(props: { defaultFileType?: FileTypes }) {

	const { order, refetchOrder } = useContext(MaterialOrderContext);

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files}
			orderID={order.details.materialOrderID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.MaterialOrder}
			orderTypeID={order.details.moTypeID}
			defaultFileType={props.defaultFileType}
			useFileTypes={true}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
			hideDeleteButton={true}
		/>
	)
}
